export default "__VITE_ASSET__BLDlTa8Y__"